<!-- 个人中心 -->
<template>
  <div class="mine-box">
    <van-popup
      v-model="show"
      position="left"
      :style="{ height: '100%' ,width:'60%'}"
      @click-overlay="sendMessage"
    >
      <div class="min-user">
        <img :src="userInfo==''?require('@/assets/img/home/user.png'):userInfo.logo" />
        <p class="login-tips">{{userInfo.contact}}</p>
      </div>
      <div class="min-info">
        <div class="min-edit" @click="go(0)">
          <span>基本资料</span>
          <img src="@/assets/img/position/into.png" />
        </div>
        <div class="min-edit" @click="go(1)">
          <span>面试管理</span>
          <img src="@/assets/img/position/into.png" />
        </div>
        <div class="min-edit" @click="wechat(wechatNum)">
          <span>{{is_bind_wechat}}</span>
          <!-- <img src="@/assets/img/position/into.png" /> -->
        </div>
        <div class="min-edit" @click="go(2)">
          <span>退出登录</span>
          <!-- <img src="@/assets/img/position/into.png" /> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { logout, getCompanyDetail, queryPersonalInfo ,wechatUnbind,wechatBind} from "@/api/apiData";
import { Dialog, Toast } from "vant";
import { mapState, mapMutations } from "vuex";
import GetQueryString from '@/until/getParams'
export default {
  components: {},
  props: ["showPoup"],
  data() {
    return {
      userInfo: "", //用户信息
      wechatNum: "",
      is_bind_wechat: ""
    };
  },
  computed: {
    show: {
      get() {
        return this.showPoup;
      },
      set() {}
    },
    ...mapState(["token", "logins"])
  },
  methods: {
    ...mapMutations(["getToken", "refreshCode"]),
    sendMessage() {
      this.$emit("sendMsg", false);
    },
    // 路由跳转
    go(val) {
      switch (val) {
        case 0:
          // 基本资料
          this.$router.push({
            name: "Information",
            query: {
              type: 0
            }
          });
          break;
        case 1:
          // 面试管理
          this.$router.push({
            name: "interviewResult"
          });
          break;
        case 2:
          this.sendMessage();
          // 退出登录
          Dialog.confirm({
            title: "退出登录",
            message: "确定退出登录吗"
          })
            .then(() => {
              logout({ token: this.mapState }).then(res => {
                // //(res);
                if (res.code == 1) {
                  Toast.success({
                    message: "退出成功",
                    forbidClick: true
                  });
                  this.getToken(["", ""]);
                  setTimeout(() => {
                    this.$router.replace({
                      name: "Index"
                    });
                  }, 2000);
                } else {
                  Toast(res.msg);
                }
              });
            })
            .catch(() => {});
          break;
      }
    },
    // 微信绑定
    wechat(wechatNum) {
      const that = this;
      if (wechatNum == 0) {
        //绑定
        that.refreshCode(2);
        var params = {
          appid: "wx0d3c07901732c258",
          redirect_uri: "https%3a%2f%2fncxtyjrwork.nccloudmedia.com%2fweb%2f%23%2fHomeBoss%2fhome%2fjobSearch",
          response_type: "code",
          scope: "snsapi_userinfo",
          state: 123456
        };
        window.location.href = `https://ncymkj.doudou00.com/get-weixin-code.html?appid=${params.appid}&redirect_uri=${params.redirect_uri}&response_type=${params.response_type}&scope=${params.scope}&state=${params.state}`;
      } else {
        //解绑
        this.sendMessage();
        Dialog.confirm({
          title: "提示",
          message: "确定将该账号与微信解绑吗？"
        })
          .then(() => {
            //(22);
            wechatUnbind({ token: that.token }).then(res => {
              //(res);
              if (res.code == 1) {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
                that.queryInfo();
              } else {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    // 查询
    queryInfo() {
      queryPersonalInfo({ token: this.token }).then(res => {
        // //(res);
        if (res.code == 1) {
          if (res.data.is_bind_wechat == 0) {
            this.is_bind_wechat = "微信绑定";
            if (GetQueryString("code")) {
              if (this.logins == 2) {
                wechatBind({
                  token: this.token,
                  code: GetQueryString("code")
                }).then(res => {
                  // //(res);
                  if (res.code == 1) {
                    Toast.success({
                      forbidClick: true,
                      message: res.msg
                    });
                    this.refreshCode(1);
                    this.queryInfo();
                  } else {
                    this.refreshCode(1);
                    Toast.fail({
                      forbidClick: true,
                      message: res.msg
                    });
                  }
                });
              }
            }
          } else {
            this.is_bind_wechat = "解绑微信";
          }
          this.wechatNum = res.data.is_bind_wechat;
        }
      });
    }
  },
  created() {},
  mounted() {
    getCompanyDetail({ token: this.token }).then(res => {
      // //(res);
      if (res.code == 1) {
        this.userInfo = res.data;
      }
    });
    this.queryInfo();
  }
};
</script>
<style lang='less' scoped>
/deep/.van-overlay {
  z-index: 2004 !important;
  top: 0 !important;
}
/deep/.van-popup {
  z-index: 2005 !important;
  .van-button {
    position: fixed;
    bottom: 0.3rem;
  }
  .min-user {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem 0 0;
    .login-tips {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      padding-top: 0.2rem;
    }
    img {
      width: 1.32rem;
      height: 1.32rem;
      // border-radius: 50%;
    }
    p {
      margin-top: 0.18rem;
      text-align: center;
    }
  }
  .min-info {
    margin-top: 0.2rem;
    .min-edit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.3rem 0.5rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.2rem;
      }
      span {
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.2rem;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>